import styled from "styled-components";

import { colors } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

const OffCanvasTrayFooter = styled.div`
  padding: 25px 40px;
  flex-shrink: 0;
  background-color: ${colors.white};
  ${breakpoints.smDown} {
    padding: 20px 15px;
  }
`;

export default OffCanvasTrayFooter;
